import type {
  IntakeAnswers,
  IntakeAnswerValue,
  IntakeQuestion,
} from "../../registry/types";

/**
 * Validation: every intake question is required. v1 only supports
 * single-select; the answer must be a non-empty string matching one of
 * the registered option values.
 *
 * Lives in its own file (no design-system imports) so the spec doesn't
 * pull in CSS modules through the React component graph.
 */
export function isAnswered(
  question: IntakeQuestion,
  value: IntakeAnswerValue | undefined,
): boolean {
  if (value == null) return false;
  if (typeof value !== "string" || value.length === 0) return false;
  return question.options.some((o) => o.value === value);
}

export function allQuestionsAnswered(
  questions: IntakeQuestion[],
  answers: IntakeAnswers,
): boolean {
  return questions.every((q) => isAnswered(q, answers[q.id]));
}
